import { Component, OnInit, Output, Input } from '@angular/core';

import { BaseComponent } from '../../base.component';
import { SessionService } from '../../shared/session.service';
import { ExternalToolbarConfig } from '../../shared/models/external-toolbar-config';

@Component({
  selector: 'app-external-toolbar',
  templateUrl: './external-toolbar.component.html',
  styleUrls: ['./external-toolbar.component.css']
})
export class ExternalToolbarComponent extends BaseComponent implements OnInit {
  constructor(
    public sessionService: SessionService) {
    super();
  }

  @Input() config: ExternalToolbarConfig;

  ngOnInit() {
    // Had to create the script element from code because Angular will remove all script tags in the html file
    const script = document.createElement('script');
    script.src = '//' + this.config.productNavBarJs;
    script.id = 'external-toolbar';
    script.setAttribute('data-url', this.config.productNavBarDataUrl);
    script.setAttribute('data-account-id', this.config.accountId);
    script.setAttribute('data-app-id', this.config.appId);
    document.body.appendChild(script);

    // Save the toolbar config to the session because we remove the querystring params when page loads
    this.sessionService.setExternalToolBarConfig(this.config);

    this.setupLogoutHandler();
  }

  setupLogoutHandler() {
    // Setup a logout handler to end the user's session when the user logs out through the external toolbar
    setTimeout(() => {
      var elements = document.getElementsByClassName('pnb__navigation-bar__item pnb__navigation-bar__item--link pnb__navigation-bar__item--dropdown-item');

      // Retry to find the elements if the toolbar is not loaded yet
      if (elements.length === 0) {
        this.setupLogoutHandler();
        return;
      }

      for (var i = 0; i < elements.length; i++) {
        if (elements[i].innerHTML === 'Sign Out') {
          elements[i].addEventListener('click', () => {
            // Setting IsLoggingOut to true prevents redirects to the login page
            this.sessionService.isLoggingOut = true;
            this.sessionService.clear();
          });
        }
      }
    }, 2000);
  }
}
